import React, { useState, useEffect } from 'react';
import { Layout, Typography, Select, Tabs, Input, Button, Form, Row, Col, DatePicker, Table, Upload, Space, Divider, Checkbox, Avatar, Card, Modal, Descriptions } from 'antd';
import { UserOutlined, EnvironmentOutlined, UploadOutlined, LogoutOutlined, EditOutlined, EyeOutlined, FileOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import './ServiceProviders.css';
import './SupportActivity.css';
import './SupportPage.css';
import moment from 'moment';

const { Content, Header } = Layout;
const { Title, Text } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;
const { Search } = Input;

const ServiceProviders = () => {
  const [filter, setFilter] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState('3');
  const [form] = Form.useForm();
  const [supportForm] = Form.useForm();
  const [editForm] = Form.useForm();
  const [documentForm] = Form.useForm();
  const [hoveredCard, setHoveredCard] = useState(null);
  const [supportHistory, setSupportHistory] = useState([]);
  const [activityData, setActivityData] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [admins, setAdmins] = useState([]); // Nouvel état pour les admins
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSupportHistory = async () => {
      try {
        const response = await fetch('/backend/get_support_history.php', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        const data = await response.json();
        console.log('Données historiques reçues:', data);
        if (response.ok) {
          setSupportHistory(data);
        } else {
          console.error('Erreur lors de la récupération de l\'historique:', data.error);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération de l\'historique:', error);
      }
    };

    const fetchServiceActivities = async () => {
      try {
        const response = await fetch('/backend/get_service_activities.php', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        const data = await response.json();
        console.log('Activités reçues:', data);
        if (response.ok) {
          setActivityData(data.activities || []); // Correction ici
        } else {
          console.error('Erreur lors de la récupération des activités:', data.error);
          setActivityData([]); // Fallback à un tableau vide
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des activités:', error);
        setActivityData([]); // Fallback à un tableau vide
      }
    };

    const fetchDocuments = async () => {
      try {
        const response = await fetch('/backend/get_documents.php', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        const data = await response.json();
        console.log('Documents reçus:', data);
        if (response.ok) {
          setDocuments(data);
        } else {
          console.error('Erreur lors de la récupération des documents:', data.error);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des documents:', error);
      }
    };

    const fetchAdmins = async () => {
      try {
        console.log('Récupération des admins depuis /backend/get_admins.php');
        const response = await fetch('/backend/get_admins.php', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        console.log('Statut HTTP:', response.status);
        const text = await response.text();
        console.log('Réponse brute:', text);
        let data;
        try {
          data = JSON.parse(text);
          console.log('Réponse:', data);
        } catch (e) {
          console.error('Erreur de parsing JSON:', e, 'Texte reçu:', text);
          throw new Error('Réponse non-JSON');
        }
        if (response.ok) {
          setAdmins(data.admins);
        } else {
          console.error('Erreur lors de la récupération des admins:', data.error);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des admins:', error);
      }
    };

    fetchSupportHistory();
    fetchServiceActivities();
    fetchDocuments();
    fetchAdmins();
  }, []);

  const handleFilterChange = (value) => {
    setFilter(value);
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
  };

  const onFinish = async (values) => {
    try {
      const payload = {
        date: values.date ? values.date.format('YYYY-MM-DD') : null,
        location: values.location,
        serviceProvider: values.serviceProvider, // Envoie l'email de l'admin
        primaryStaff: values.primaryStaff,
        secondaryStaff: values.secondaryStaff || null,
        staffName: values.staffName || null,
        activityType: values.activityType,
        serviceDelivery: values.serviceDelivery,
        notes: values.notes || null,
      };

      console.log('Payload activité:', payload);

      const response = await fetch('/backend/save_service_activity.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        const activitiesResponse = await fetch('/backend/get_service_activities.php', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        const activitiesData = await activitiesResponse.json();
        if (activitiesResponse.ok) {
          setActivityData(activitiesData.activities || []); // Correction ici
        }
        alert('Activité sauvegardée avec succès !');
        form.resetFields();
      } else {
        setErrorMessage(result.error || 'Erreur lors de la sauvegarde de l\'activité.');
        setIsErrorModalVisible(true);
      }
    } catch (error) {
      console.error('Erreur lors de la sauvegarde de l\'activité:', error);
      setErrorMessage('Une erreur s\'est produite lors de la sauvegarde de l\'activité.');
      setIsErrorModalVisible(true);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
    alert('Veuillez corriger les erreurs dans le formulaire.');
  };

  const onSupportSave = async () => {
    try {
      await supportForm.validateFields();
      const values = supportForm.getFieldsValue();
      
      const needs = supportData
        .filter(item => item.need)
        .map(item => item.name);
      const connections = supportData
        .filter(item => item.connected)
        .map(item => item.name);

      const payload = {
        supportNumber: values.supportNumber,
        recordType: values.recordType,
        needs: needs,
        connections: connections,
        status: values.status,
      };

      console.log('Payload envoyé:', payload);

      const response = await fetch('/backend/save_support.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        const historyResponse = await fetch('/backend/get_support_history.php', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        const historyData = await historyResponse.json();
        if (historyResponse.ok) {
          setSupportHistory(historyData);
        }
        alert('Informations de support sauvegardées avec succès !');
      } else {
        setErrorMessage(result.error || 'Erreur lors de la sauvegarde des informations.');
        setIsErrorModalVisible(true);
      }
    } catch (error) {
      console.error('Erreur lors de la sauvegarde:', error);
      if (error.errorFields) {
        alert('Veuillez remplir tous les champs obligatoires.');
      } else {
        setErrorMessage('Une erreur s\'est produite lors de la sauvegarde.');
        setIsErrorModalVisible(true);
      }
    }
  };

  const handleLogout = async () => {
    try {
      const response = await fetch('/backend/logout.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });

      const data = await response.json();

      if (response.ok) {
        alert(data.message || 'Déconnexion réussie');
        navigate('/login');
      } else {
        alert(data.error || 'Erreur lors de la déconnexion.');
      }
    } catch (error) {
      alert('Une erreur s\'est produite lors de la déconnexion.');
    }
  };

  const handleViewRecord = (record) => {
    setSelectedRecord(record);
    setIsViewModalVisible(true);
  };

  const handleEditRecord = (record) => {
    setSelectedRecord(record);
    editForm.setFieldsValue({
      supportNumber: record.support_number,
      recordType: record.record_type,
      status: record.status,
    });
    const updatedSupportData = services.map((service) => ({
      name: service,
      need: record.needs.includes(service),
      connected: record.connections.includes(service),
    }));
    setSupportData(updatedSupportData);
    setIsEditModalVisible(true);
  };

  const handleUpdateRecord = async () => {
    try {
      await editForm.validateFields();
      const values = editForm.getFieldsValue();
      
      const needs = supportData
        .filter(item => item.need)
        .map(item => item.name);
      const connections = supportData
        .filter(item => item.connected)
        .map(item => item.name);

      const payload = {
        id: selectedRecord.key,
        supportNumber: values.supportNumber,
        recordType: values.recordType,
        needs: needs,
        connections: connections,
        status: values.status,
      };

      console.log('Payload de mise à jour:', payload);

      const response = await fetch('/backend/update_support.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        const historyResponse = await fetch('/backend/get_support_history.php', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        const historyData = await historyResponse.json();
        if (historyResponse.ok) {
          setSupportHistory(historyData);
        }
        setIsEditModalVisible(false);
        alert('Informations mises à jour avec succès !');
      } else {
        setErrorMessage(result.error || 'Erreur lors de la mise à jour des informations.');
        setIsErrorModalVisible(true);
      }
    } catch (error) {
      console.error('Erreur lors de la mise à jour:', error);
      if (error.errorFields) {
        alert('Veuillez remplir tous les champs obligatoires.');
      } else {
        setErrorMessage('Une erreur s\'est produite lors de la mise à jour.');
        setIsErrorModalVisible(true);
      }
    }
  };

  const activityColumns = [
    { title: 'Date', dataIndex: 'activity_date', key: 'activity_date' },
    { title: 'Location', dataIndex: 'location', key: 'location' },
    { title: 'Service Provider', dataIndex: 'service_provider', key: 'service_provider' },
    { title: 'Primary Staff', dataIndex: 'primary_staff', key: 'primary_staff' },
    { title: 'Secondary Staff', dataIndex: 'secondary_staff', key: 'secondary_staff' },
    { title: 'Staff Name', dataIndex: 'staff_name', key: 'staff_name' },
    { title: 'Activity Type', dataIndex: 'activity_type', key: 'activity_type' },
    { title: 'Service Delivery', dataIndex: 'service_delivery', key: 'service_delivery' },
    { title: 'Notes', dataIndex: 'notes', key: 'notes' },
    { title: 'Created At', dataIndex: 'created_at', key: 'created_at' },
    {
      title: 'Documents',
      key: 'documents',
      render: () => (
        documents.length > 0 ? (
          <Space>
            {documents.map((doc) => (
              <a
                key={doc.id}
                href={`/backend/${doc.file_path}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FileOutlined /> {doc.description}
              </a>
            ))}
          </Space>
        ) : (
          <Text type="secondary">Aucun document</Text>
        )
      ),
    },
  ];

  const uploadProps = {
    name: 'file',
    multiple: false,
    beforeUpload: () => false,
    onChange(info) {
      if (info.fileList.length > 0) {
        documentForm.setFieldsValue({ upload: info.fileList });
      } else {
        documentForm.setFieldsValue({ upload: null });
      }
    },
  };

  const handleDocumentUpload = async () => {
    try {
      await documentForm.validateFields();
      const values = documentForm.getFieldsValue();

      const file = values.upload[0].originFileObj;
      const description = values.description;

      const formData = new FormData();
      formData.append('file', file);
      formData.append('description', description);

      const response = await fetch('/backend/upload_document.php', {
        method: 'POST',
        credentials: 'include',
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        const documentsResponse = await fetch('/backend/get_documents.php', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        const documentsData = await documentsResponse.json();
        if (documentsResponse.ok) {
          setDocuments(documentsData);
        }
        alert('Document sauvegardé avec succès !');
        documentForm.resetFields();
      } else {
        setErrorMessage(result.error || 'Erreur lors de l\'upload du document.');
        setIsErrorModalVisible(true);
      }
    } catch (error) {
      console.error('Erreur lors de l\'upload du document:', error);
      setErrorMessage('Une erreur s\'est produite lors de l\'upload du document.');
      setIsErrorModalVisible(true);
    }
  };

  const services = [
    "Drop-in Services (Shower, Mail etc)",
    "Emergency Shelter",
    "Eviction Prevention Financial Help",
    "Food Assistance (Hot Meals, Food Baskets etc)",
    "Foreclosure Prevention Financial Help",
    "Healthcare and Medical Services",
    "Job Training",
    "Housing Search Assistance",
    "Legal Aid",
    "Mental Health Services",
    "Rent and Security Deposit Help",
    "Transportation",
    "Substance Use and Treatment Services",
  ];

  const [supportData, setSupportData] = useState(
    services.map((service) => ({
      name: service,
      need: false,
      connected: false,
    }))
  );

  const handleCheckboxChange = (index, key, value) => {
    const updatedData = [...supportData];
    if (key === "need" && value) {
      updatedData[index].connected = false;
    } else if (key === "connected" && value) {
      updatedData[index].need = false;
    }
    updatedData[index][key] = value;
    setSupportData(updatedData);
  };

  const renderServiceProviders = () => (
    <div className="directory-section">
      <Title level={2} className="heading-primary">
        Service Providers Directory
      </Title>
      <Text className="text-body">
        Find and connect with local service providers who can assist with housing and support services.
      </Text>
      <div className="search-filter-container">
        <Search
          placeholder="Search providers..."
          onSearch={handleSearch}
          className="search-input"
          enterButton
        />
        <Select
          placeholder="Filter by category"
          className="filter-select"
          onChange={handleFilterChange}
          value={filter || undefined}
          dropdownStyle={{ borderRadius: 8 }}
        >
          <Option value="physical-health">Physical Health</Option>
          <Option value="mental-wellness">Mental Wellness</Option>
          <Option value="substance-abuse">Substance Abuse</Option>
          <Option value="legal-assistance">Legal Assistance</Option>
          <Option value="employment-assistance">Employment Assistance & Public Benefits</Option>
          <Option value="financial-assistance">Financial Assistance & Public Benefits</Option>
          <Option value="military-veteran-resources">Military & Veteran Resources</Option>
          <Option value="senior-resources">Senior Resources</Option>
          <Option value="youth-resources">Youth Resources</Option>
          <Option value="accessibility-independent-living">Accessibility & Independent Living</Option>
          <Option value="information-referral">Information & Referral</Option>
        </Select>
      </div>
      <div className="providers-list">
        <Text className="text-muted">No providers found. Try adjusting your search or filter.</Text>
      </div>
    </div>
  );

  const renderSupportActivity = () => (
    <div className="activity-section">
      <Title level={3} className="heading-secondary">
        Add New Service Activity
      </Title>
      <Text className="text-body">
        Record your interactions with service providers and track service delivery.
      </Text>
      <Form
        form={form}
        name="supportActivity"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        className="activity-form"
      >
        <Row gutter={[24, 24]}>
          <Col span={12}>
            <Form.Item
              label="Date *"
              name="date"
              rules={[{ required: true, message: 'Please select a date!' }]}
            >
              <DatePicker className="form-input" placeholder="Select a date" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Location *"
              name="location"
              rules={[{ required: true, message: 'Please enter a location!' }]}
            >
              <Input
                prefix={<EnvironmentOutlined />}
                placeholder="Street Name, City"
                className="form-input"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 24]}>
          <Col span={12}>
            <Form.Item
              label="Service Provider Organization *"
              name="serviceProvider"
              rules={[{ required: true, message: 'Please select an organization!' }]}
            >
              <Select placeholder="Select Provider" className="form-input">
                {admins.map((admin) => (
                  <Option key={admin.email} value={admin.email}>
                    {admin.full_names}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Primary Staff Contact *"
              name="primaryStaff"
              rules={[{ required: true, message: 'Please enter a contact!' }]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Phone or Email"
                className="form-input"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 24]}>
          <Col span={12}>
            <Form.Item label="Secondary Staff Contact" name="secondaryStaff">
              <Input
                prefix={<UserOutlined />}
                placeholder="Phone or Email"
                className="form-input"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Staff Name" name="staffName">
              <Input placeholder="Enter Staff Name" className="form-input" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 24]}>
          <Col span={12}>
            <Form.Item
              label="Activity Type *"
              name="activityType"
              rules={[{ required: true, message: 'Please select an activity type!' }]}
            >
              <Select placeholder="Select Type" className="form-input">
                <Option value="type1">Type 1</Option>
                <Option value="type2">Type 2</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Service Delivery *"
              name="serviceDelivery"
              rules={[{ required: true, message: 'Please select a delivery type!' }]}
            >
              <Select placeholder="Select Delivery" className="form-input">
                <Option value="delivery1">Delivery 1</Option>
                <Option value="delivery2">Delivery 2</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item label="Notes" name="notes">
          <Input.TextArea placeholder="Enter additional notes..." className="form-textarea" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" className="submit-button">
            Save Activity
          </Button>
        </Form.Item>
      </Form>

      <div className="history-section">
        <Title level={3} className="heading-secondary">
          Activity History
        </Title>
        <Text className="text-body">
          Your recent service interactions.
        </Text>
        <Table
          columns={activityColumns}
          dataSource={activityData}
          pagination={false}
          bordered={false}
          className="history-table"
          scroll={{ x: 1200 }}
        />
      </div>

      <div className="documents-section">
        <Title level={3} className="heading-secondary">
          Documents
        </Title>
        <Text className="text-body">
          Upload and manage documents related to your service activities.
        </Text>
        <Form
          form={documentForm}
          layout="vertical"
          className="documents-form"
          onFinish={handleDocumentUpload}
        >
          <Form.Item
            label="Upload Document"
            name="upload"
            rules={[{ required: true, message: 'Please upload a document!' }]}
            valuePropName="fileList"
            getValueFromEvent={(e) => e.fileList}
          >
            <Upload {...uploadProps}>
              <Button icon={<UploadOutlined />} className="upload-button">
                Choose File
              </Button>
            </Upload>
            <Text className="text-muted">
              Maximum file size: 5MB. Supported formats: PDF, Word, JPEG, PNG
            </Text>
          </Form.Item>
          <Form.Item
            label="Enter document description"
            name="description"
            rules={[{ required: true, message: 'Please enter a document description!' }]}
          >
            <Input.TextArea placeholder="Enter document description" className="form-textarea" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="submit-button">
              Upload Document
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );

  const renderSupportServices = () => (
    <div className="support-services-section">
      <Divider orientation="left" className="heading-secondary">
        Support and Service Needs and Connections
      </Divider>
      <div className="support-header">
        <div className="support-col service-name-header">Support Services</div>
        <div className="support-col text-center">I Need</div>
        <div className="support-col text-center">I'm Connected to</div>
      </div>

      {supportData.map((item, index) => (
        <div className="support-row" key={index}>
          <div className="support-col service-name">{item.name}</div>
          <div className="support-col text-center">
            <Checkbox
              checked={item.need}
              onChange={(e) => handleCheckboxChange(index, "need", e.target.checked)}
              className="custom-checkbox"
            />
          </div>
          <div className="support-col text-center">
            <Checkbox
              checked={item.connected}
              onChange={(e) => handleCheckboxChange(index, "connected", e.target.checked)}
              className="custom-checkbox"
            />
          </div>
        </div>
      ))}

      <Divider orientation="left" className="heading-secondary">
        Support Record Information
      </Divider>
      <Form form={supportForm} layout="vertical" className="support-form">
        <Form.Item
          name="supportNumber"
          label="Your Support Record Number"
          rules={[{ required: true, message: 'Please enter your support record number!' }]}
        >
          <Input size="large" placeholder="Enter your record number" className="form-input" />
        </Form.Item>
        <Form.Item
          name="recordType"
          label="Record Type"
          rules={[{ required: true, message: 'Please select a record type!' }]}
        >
          <Select size="large" placeholder="Select record type" className="form-input">
            <Option value="initial">Initial</Option>
            <Option value="followup">Follow-up</Option>
            <Option value="final">Final</Option>
          </Select>
        </Form.Item>
        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: 'Please select a status!' }]}
        >
          <Select size="large" placeholder="Select status" className="form-input">
            <Option value="pending">Pending</Option>
          </Select>
        </Form.Item>
        <Form.Item>
          <Button type="primary" size="large" onClick={onSupportSave} className="submit-button">
            Save Support Information
          </Button>
        </Form.Item>
      </Form>

      <Divider orientation="left" className="heading-secondary">
        Support History
      </Divider>
      <div className="history-section">
        <Text className="text-body">
          View your past support records.
        </Text>
        <div className="record-files">
          {supportHistory.length > 0 ? (
            supportHistory.map((record) => (
              <Card
                key={record.key}
                className="record-file-card"
                hoverable
                actions={[
                  <EyeOutlined key="view" onClick={() => handleViewRecord(record)} />,
                  <EditOutlined key="edit" onClick={() => handleEditRecord(record)} />,
                ]}
              >
                <Card.Meta
                  title={`Record #${record.support_number || 'N/A'}`}
                  description={`Status: ${record.status || 'N/A'}`}
                />
              </Card>
            ))
          ) : (
            <Text className="text-muted">No support records found.</Text>
          )}
        </div>
      </div>

      <Modal
        title="Support Record Details"
        visible={isViewModalVisible}
        onCancel={() => setIsViewModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setIsViewModalVisible(false)}>
            Close
          </Button>,
          <Button
            key="edit"
            type="primary"
            icon={<EditOutlined />}
            onClick={() => {
              setIsViewModalVisible(false);
              handleEditRecord(selectedRecord);
            }}
          >
            Edit
          </Button>,
        ]}
      >
        {selectedRecord && (
          <Descriptions column={1} bordered>
            <Descriptions.Item label="Support Number">{selectedRecord.support_number || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Record Type">{selectedRecord.record_type || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Status">{selectedRecord.status || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Needs">
              {Array.isArray(selectedRecord.needs) && selectedRecord.needs.length > 0
                ? selectedRecord.needs.join(', ')
                : 'None'}
            </Descriptions.Item>
            <Descriptions.Item label="Connections">
              {Array.isArray(selectedRecord.connections) && selectedRecord.connections.length > 0
                ? selectedRecord.connections.join(', ')
                : 'None'}
            </Descriptions.Item>
            <Descriptions.Item label="Created At">{selectedRecord.created_at}</Descriptions.Item>
          </Descriptions>
        )}
      </Modal>

      <Modal
        title="Edit Support Record"
        visible={isEditModalVisible}
        onCancel={() => setIsEditModalVisible(false)}
        onOk={handleUpdateRecord}
        okText="Save Changes"
        cancelText="Cancel"
      >
        <Form form={editForm} layout="vertical" className="support-form">
          <Form.Item
            name="supportNumber"
            label="Your Support Record Number"
            rules={[{ required: true, message: 'Please enter your support record number!' }]}
          >
            <Input size="large" placeholder="Enter your record number" className="form-input" />
          </Form.Item>
          <Form.Item
            name="recordType"
            label="Record Type"
            rules={[{ required: true, message: 'Please select a record type!' }]}
          >
            <Select size="large" placeholder="Select record type" className="form-input">
              <Option value="initial">Initial</Option>
              <Option value="followup">Follow-up</Option>
              <Option value="final">Final</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="status"
            label="Status"
            rules={[{ required: true, message: 'Please select a status!' }]}
          >
            <Select size="large" placeholder="Select status" className="form-input">
              <Option value="pending">Pending</Option>
            </Select>
          </Form.Item>
          <Divider orientation="left" className="heading-secondary">
            Support and Service Needs and Connections
          </Divider>
          <div className="support-header">
            <div className="support-col service-name-header">Support Services</div>
            <div className="support-col text-center">I Need</div>
            <div className="support-col text-center">I'm Connected to</div>
          </div>
          {supportData.map((item, index) => (
            <div className="support-row" key={index}>
              <div className="support-col service-name">{item.name}</div>
              <div className="support-col text-center">
                <Checkbox
                  checked={item.need}
                  onChange={(e) => handleCheckboxChange(index, "need", e.target.checked)}
                  className="custom-checkbox"
                />
              </div>
              <div className="support-col text-center">
                <Checkbox
                  checked={item.connected}
                  onChange={(e) => handleCheckboxChange(index, "connected", e.target.checked)}
                  className="custom-checkbox"
                />
              </div>
            </div>
          ))}
        </Form>
      </Modal>

      <Modal
        title="Erreur"
        visible={isErrorModalVisible}
        onCancel={() => setIsErrorModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setIsErrorModalVisible(false)}>
            Fermer
          </Button>,
        ]}
      >
        <Text>{errorMessage}</Text>
      </Modal>
    </div>
  );

  return (
    <Layout style={{ minHeight: '100vh', background: '#f9fafb' }}>
      <Header
        style={{
          background: '#fff',
          padding: '0 30px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
          borderBottom: '1px solid #e5e7eb',
          transition: 'all 0.3s ease',
        }}
        onMouseEnter={() => setHoveredCard('nav')}
        onMouseLeave={() => setHoveredCard(null)}
      >
        <Space align="center">
          <Avatar
            icon={<UserOutlined />}
            style={{ backgroundColor: '#2b6cb0', marginRight: 12, transition: 'transform 0.3s ease' }}
            className={hoveredCard === 'nav' ? 'nav-avatar-hover' : ''}
          />
          <Typography.Title
            level={4}
            style={{ margin: 0, color: '#2b6cb0', fontWeight: 600, transition: 'color 0.3s ease' }}
            className={hoveredCard === 'nav' ? 'nav-title-hover' : ''}
          >
            NH Guide
          </Typography.Title>
        </Space>
        <div style={{ flex: 1 }} />
        <Space size={20}>
          <Link
            to="/home"
            style={{ color: '#1a1a1a', fontWeight: 500, padding: '0 15px', transition: 'color 0.3s ease' }}
            onMouseEnter={(e) => (e.target.style.color = '#1e4a8a')}
            onMouseLeave={(e) => (e.target.style.color = '#1a1a1a')}
          >
            Home
          </Link>
          <Link
            to="/profile"
            style={{ color: '#1a1a1a', fontWeight: 500, padding: '0 15px', transition: 'color 0.3s ease' }}
            onMouseEnter={(e) => (e.target.style.color = '#1e4a8a')}
            onMouseLeave={(e) => (e.target.style.color = '#1a1a1a')}
          >
            Profile
          </Link>
          <Link
            to="/services-resources"
            style={{ color: '#1a1a1a', fontWeight: 500, padding: '0 15px', transition: 'color 0.3s ease' }}
            onMouseEnter={(e) => (e.target.style.color = '#1e4a8a')}
            onMouseLeave={(e) => (e.target.style.color = '#1a1a1a')}
          >
            Services and Resources
          </Link>
          <Link
            to="/privacy-data-sharing"
            style={{ color: '#1a1a1a', fontWeight: 500, padding: '0 15px', transition: 'color 0.3s ease' }}
            onMouseEnter={(e) => (e.target.style.color = '#1e4a8a')}
            onMouseLeave={(e) => (e.target.style.color = '#1a1a1a')}
          >
            Privacy and Data Sharing
          </Link>
          <Button
            type="link"
            icon={<LogoutOutlined />}
            style={{ color: '#1a1a1a', fontWeight: 500, padding: '0 15px', transition: 'color 0.3s ease' }}
            onMouseEnter={(e) => (e.target.style.color = '#e74c3c')}
            onMouseLeave={(e) => (e.target.style.color = '#1a1a1a')}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Space>
      </Header>

      <Content style={{ padding: '40px 20px', display: 'flex', justifyContent: 'center' }}>
        <div className="service-providers-container">
          <Title level={1} className="heading-primary">
            Support
          </Title>
          <div className="support-section">
            <Text className="text-body">
              Manage the support and services you need and are connected to. Update this section anytime.
            </Text>
            <Tabs
              activeKey={activeTab}
              onChange={setActiveTab}
              className="custom-tabs"
              tabBarStyle={{ marginBottom: 24 }}
            >
              <TabPane tab="Support Services" key="1">
                {renderSupportServices()}
              </TabPane>
              <TabPane tab="Service Activities" key="2">
                {renderSupportActivity()}
              </TabPane>
              <TabPane tab="Service Providers" key="3">
                {renderServiceProviders()}
              </TabPane>
            </Tabs>
          </div>
        </div>
      </Content>
    </Layout>
  );
};

export default ServiceProviders;